export default __webpack_public_path__ + "static/media/collection.f3c4a37b.svg";